import DashboardStudentStats from './DashboardStudentStats';
export default DashboardStudentStats;
